import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useSnackbar } from 'notistack';

import { environment } from '../environment';

interface Props {
  readonly children: ReactNode;
}

export const DisabledFeatureInStrictMode = ({ children }: Readonly<Props>) => {
  const { enqueueSnackbar } = useSnackbar();

  const mustDisableFeature =
    environment.strictMode && environment.isDevelopment;

  useEffect(() => {
    if (mustDisableFeature) {
      enqueueSnackbar(
        'Fonctionnalité incompatible avec StrictMode. Debugage nécessaire (ou désactiver environment.strictMode).',
        { preventDuplicate: true, variant: 'error' },
      );
    }
  }, [enqueueSnackbar, mustDisableFeature]);

  return mustDisableFeature ? null : children;
};
